import { PageId } from 'constants/pages'

export const enum PageIdWoofzVday65 {
  SUBSCRIPTIONS_VDAY_65 = PageId.SUBSCRIPTIONS_VDAY_65,
  CHAT_UPSELL_VDAY_65 = PageId.CHAT_UPSELL_VDAY_65,
  UPSELL_VDAY_65 = PageId.UPSELL_VDAY_65,
  DOWNLOAD_VDAY_65 = PageId.DOWNLOAD_VDAY_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
